import { useEffect, useState } from "react";
import {
  getCookieConsent,
  onCookieConsentChange,
  type CookieConsent,
} from "@/lib/cookieConsent";

export function useCookieConsent() {
  const [consent, setConsent] = useState<CookieConsent | null>(() => getCookieConsent());
  useEffect(() => onCookieConsentChange(setConsent), []);
  return consent;
}
